var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},_vm._l((_vm.modals),function(params){return _c('the-modal-component',{key:params.id,attrs:{"params":params}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }